import React, { useEffect, useState } from 'react';
import {
  Container,
  Form,
  Row,
  Col,
  Button,
} from '@themesberg/react-bootstrap';
import { get, post } from '../../../services/back.service';
import ListTables from '../../shared/tables';

function FormInfoFluids({ id }) {
  const [selectparts, setSelectParts] = useState('');
  const [selectstate, setSelectState] = useState('');
  const [parts, setParts] = useState([]);
  const [states, setStates] = useState([]);
  const [infoFluids, setInfoFluids] = useState([]);
  const [msgButton, setMsgButton] = useState('Guardar Informacion')

  const saveForm = (e) => {
    e.preventDefault()
    infoFluids.push({
      id_part: selectparts,
      id_state: selectstate,
    });
    setSelectParts('');
    setSelectState('');
    setInfoFluids(infoFluids);
    //generalUpdate('infoFluids', infoFluids);
  };

  const deleteItem = (idx) => {
    infoFluids.splice(idx - 1, 1);
    setInfoFluids([...infoFluids]);
    //generalUpdate('infoFluids', infoFluids);
  };

  const editButton = (row) => {
    return (
      <Button
        title="Modificar Combustible"
        text="Editar"
        variant="outline-primary"
        onClick={() => deleteItem(row.id)}
      >Eliminar</Button>
    );
  };

  const infoTable = () => {
    // {type: 'C', id_part: '11', id_state: '1'} 
    let tmpTable = []
    for (let index = 0; index < infoFluids.length; index++) {
      const element = infoFluids[index];
      const currentpart = parts.find((e) => e.id.toString() === element.id_part.toString())
      const currentstate = states.find((e) => e.id.toString() === element.id_state.toString())
      if (currentpart && currentstate) tmpTable.push({ id: (index + 1), pieza: currentpart.name, estado: currentstate.name })
    }
    return (<ListTables
      data={tmpTable}
      editar={editButton}
      messageWd={'Agrege una parte'}
    />)
  }

  const getinfoFluids = async () => {
    const respoInfo = await get(`/peritaje/infofluidsinspection/`, {});
    if (respoInfo.success) {
      const { fluids, stateapp } = respoInfo.data;
      setParts(fluids);
      setStates(stateapp);
    } else {
      console.log(respoInfo.message);
    }
  };

  const sendInfo = async (event) => {
    event.preventDefault();
    const body = {
      type: 'F',
      data: infoFluids
    };
    const respo = await post('/peritaje/modifyinspection/fluids/' + id, body);
    if (respo.success) {
      setMsgButton('Actualizar')
    }
  };


  useEffect(() => {
    const initForm = async () => {
      const body = { type: 'F' };
      const respo = await post('/peritaje/infodetailinspection/fluids/' + id, body);
      if (respo.success) {
        const { detail } = respo.data;
        setInfoFluids(detail);
      }
    };
    getinfoFluids();
    initForm();
  }, [id]);
  return (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">Fluídos</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col xs={12} md={6}>
          <Form onSubmit={saveForm}>
            <Form.Label htmlFor="fluidos">Fluidos</Form.Label>
            <Form.Select
              name="selectparts"
              value={selectparts}
              onChange={(e) => setSelectParts(e.target.value)}
              aria-label="Default select example"
              required
            >
              <option value="">Seleccione</option>
              {parts.map((element, i) => {
                return (
                  <option key={i} value={element.id}>
                    {element.name}
                  </option>
                );
              })}
            </Form.Select>
            <Form.Label htmlFor="estado">Estado</Form.Label>
            <Form.Select
              name="selectstate"
              value={selectstate}
              onChange={(e) => setSelectState(e.target.value)}
              aria-label="Default select example"
              required
            >
              <option value="">Seleccione</option>
              {states.map((element, i) => {
                return (
                  <option key={i} value={element.id}>
                    {element.name}
                  </option>
                );
              })}
            </Form.Select>
            <Row className="my-3">
              <Col className="d-flex justify-content-end">
                <Button
                  type="submit"
                  variant="primary"
                >
                  Agregar Novedad
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col>{infoTable()}</Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo} >
            {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default FormInfoFluids;
